import { createStore } from "zustand-x"
import { makeInitAdminEntrySearch } from "@/domain/admin/model/AdminEntry"
import type { AdminEntrySearchInput } from "@/domain/admin/model/AdminEntry"
import type { EntrySummary } from "@/domain/entry/model/Entry"
import type { TournamentListItem } from "@/domain/tournament/model/Tournament"

interface AdminEntryListStoreState {
  entries: EntrySummary[]
  /** 대회 필터 선택지 */
  tournaments: TournamentListItem[]
  totalCount: number
  currentPage: number
  search: AdminEntrySearchInput
  isLoaded: boolean
  errorMessage: string
  /** 비밀번호 초기화로 발급된 임시 비밀번호 (운영자가 체육관에 전달해야 한다) */
  issuedPassword: string
}

function makeInitAdminEntryListState(): AdminEntryListStoreState {
  return {
    entries: [],
    tournaments: [],
    totalCount: 0,
    currentPage: 1,
    search: makeInitAdminEntrySearch(),
    isLoaded: false,
    errorMessage: "",
    issuedPassword: "",
  }
}

const AdminEntryListStore = createStore<AdminEntryListStoreState>(
  makeInitAdminEntryListState(),
  { name: "AdminEntryListStore" },
)

export { AdminEntryListStore, makeInitAdminEntryListState }
export type { AdminEntryListStoreState }
